module.exports = __webpack_public_path__ + "img/hero_split.993852cd.png";